import { useStorage } from '@vueuse/core'

const { currentCustomerId, currentProviderId } = useSessionData()

const staleTimeMs = 10 * 60 * 1000
const getTimeMs = () => +(new Date())
const getExpiry = () => getTimeMs() + staleTimeMs

function getContext({ useProviderScope, useCustomerScope }) {
  return [
    'teamup',
    'consumer',
    ...(useProviderScope ? [currentProviderId] : []),
    ...(useCustomerScope ? [currentCustomerId] : []),
  ].filter(key => key)
}

export function useTeamUpStorage(key = '', defaultValue, { useProviderScope = true, useCustomerScope = true, storageProvider = localStorage } = {}) {
  if (key === '')
    return
  const context = getContext({ useProviderScope, useCustomerScope })
  const path = [...context, key].filter(key => key).join('.')
  const internalValue = useStorage(
    path,
    null,
    storageProvider,
    {
      serializer: {
        read: (v: any) => v ? JSON.parse(v) : null,
        write: (v: any) => JSON.stringify(v),
      },
    },
  )
  const value = computed({
    get: () => (getTimeMs() < internalValue.value?.expiry) ? internalValue.value?.value : null,
    set: value => internalValue.value = { expiry: getExpiry(), value },
  })
  if (defaultValue !== undefined && value.value === null)
    value.value = defaultValue
  return value
}
